
export default {
    /**
     * 新增（保存草稿）
     */
    Create: 1,
    /**
     * 更新
     */
    Update: 2,
    /**
     * 保存并提交
     */
    SaveAndSubmit: 3,
    /**
     * 提交
     */
    Submit: 4,
    /**
     * 审核
     */
    Audit: 5,
    /**
     * 驳回
     */
    Reject: 6,
    /**
     * 作废
     */
    Cancel: 7,
    /**
     * 删除
     */
    Delete: 8,
    /**
     * 完成（整改通知）
     */
    Finish: 9
}